<template>
  <div class="post type-post hentry">
    <h2>
      <router-link to="/2010/12/kaip-elgtis-nutraukiant-santuoka/"
        >Kaip elgtis nutraukiant santuoką</router-link
      >
    </h2>
    <div class="comm_date">
      <span class="month">Gruodžio</span><span class="date_nr">29</span>
    </div>
    <div class="entry">
      <p>
        <strong>Santuoka gali būti nutraukta trejopai:</strong>
      </p>
      <p>
        <strong>- abiejų sutuoktinių bendru sutikimu,</strong>
      </p>
      <p><strong>- vieno sutuoktinio prašymu, </strong></p>
      <p><strong>- dėl sutuoktinių kaltės.</strong></p>
      <p>
        <strong>- Bendru abiejų sutuoktinių sutikimu</strong> išsiskirti
        paprasčiausia, tačiau tam reikalingos trys sąlygos: 1) santuokos trukmė
        ne mažiau kaip vieneri metai; 2) abu sutuoktiniai turi būti visiškai
        veiksnus; 2) jie turi būti sudarę ir pasirašę sutartį dėl santuokos
        nutraukimo pasekmių (turto pasidalijimo, santykių su kreditoriais
        nustatymo, nepilnamečių vaikų gyvenamosios vietos nustatymo, jų bei
        vienas kito išlaikymo, dalyvavimo nepilnamečius vaikus auklėjant bei
        visų kitų turtinių teisių ir pareigų).
      </p>
      <p>
        Abiejų sutuoktinių pasirašytas prašymas, nurodžius santuokos iširimo
        priežastis kartu su sutartimi dėl santuokos nutraukimo pasekmių,
        paduodamas vieno iš sutuoktinių gyvenamosios vietos apylinkės teismui.
      </p>
      <p>
        Teismas santuoką nutrauks ir patvirtins pridedamą sutartį, jeigu
        įsitikins, kad santuoka tikrai iširo ir negalima tikėtis, kad
        sutuoktiniai vėl galėtų pradėti gyventi kartu. Pvz., jeigu sutuoktiniai
        daugiau kaip metus neveda bendro ūkio ir negyvena santuokinio gyvenimo,
        reikia laikyti, kad santuoka faktiškai iširusi. Žinotina, kad po
        santuokos nutraukimo iš esmės pasikeitus aplinkybėms, sutuoktiniui ar
        išlaikomajam susirgus, tapus nedarbingam, bet kuris iš buvusių
        sutuoktinių turi teisę kreiptis į teismą dėl tokios sutarties sąlygų
        pakeitimo.
      </p>
      <p>
        Jeigu santuoką dar galima išgelbėti, teismas savo iniciatyva arba vieno
        sutuoktinio reikalavimu gali sustabdyti bylą ir nustatyti iki 6 mėnesių
        terminą sutuoktiniams susitaikyti. Sustabdyta byla atnaujinama vieno iš
        sutuoktinių prašymu nustatytam terminui praėjus. Jeigu per metus laiko
        nuo susitaikymo termino pradžios nė vienas sutuoktinis į teismą
        nesikreips, pareiškimas bus paliktas nenagrinėtu, o apsigalvojus vėliau,
        procedūrą teks pradėti iš naujo.
      </p>
      <p>
        <strong>- Vieno sutuoktinio prašymu</strong> ištuokiama, tik tada, kai
        yra bent viena iš šių sąlygų:
      </p>
      <p>
        a) vienas sutuoktinis po santuokos sudarymo teismo pripažintas
        neveiksniu arba nežinia kur esančiu,
      </p>
      <p>
        b) vienas sutuoktinis atlieka laisvės atėmimo bausmę ilgiau kaip
        vienerius metus,
      </p>
      <p>
        c) sutuoktiniai gyvena skyrium (separacija) daugiau nei vienerius metus.
      </p>
      <p>
        Prašymas paduodamas pareiškėjo gyvenamosios vietos apylinkės teismui,
        būtinai nurodant:
      </p>
      <p>1) ar yra čia minimų būtinųjų sąlygų,</p>
      <p>
        2) būdą ir sąlygas, kaip pareiškėjas įvykdys savo pareigas kitam
        sutuoktiniui ir nepilnamečiams vaikams,
      </p>
      <p>
        3) duomenys apie sutuoktinių kreditorius, pažymint, kad ieškovas yra
        pranešęs jiems apie būsimą bylą.
      </p>
      <p>
        Prašymas nagrinėjamas supaprastinto žodinio proceso tvarka. Susitaikymo
        terminas paprastai netaikomas.
      </p>
      <p>
        Žinotina, kad, atsižvelgiant į sutuoktinių amžių, santuokos trukmę,
        nepilnamečių vaikų interesus, gali būti atsisakyta nutraukti santuoką,
        jeigu tai galėtų sukelti esminės žalos kuriam nors sutuoktiniui ar jų
        nepilnamečiams vaikams.
      </p>
      <p>
        Nutraukdamas santuoką, teismas išsprendžia, kokias pavardes pasiliks
        sutuoktiniai, nepilnamečių vaikų gyvenamosios vietos ir jų išlaikymo,
        dalyvavimo vaikų auklėjime ir bendravimo su jais klausimus, taip pat
        vieno sutuoktinio išlaikymo bei jų bendro turto padalijimo klausimus.
        Esant neveiksniam sutuoktiniui, reikalinga globos (rūpybos) institucijos
        išvada.
      </p>
      <p>
        <strong>- Santuokos nutraukimas dėl sutuoktinių kaltės</strong>
        galimas tik tada, kai bendras sutuoktinių gyvenimas tapo negalimas dėl
        kurios nors iš šių priežasčių:
      </p>
      <p>
        a) jeigu sutuoktinis nuteistas už tyčinį nusikaltimą;
      </p>
      <p>b) jei jis yra neištikimas;</p>
      <p>
        c) jei jis žiauriai elgiasi su kitu sutuoktiniu ar šeimos nariais;
      </p>
      <p>
        d) jei jis paliko šeimą ir daugiau kaip metus ja nesirūpina.
      </p>
      <p>
        Atsakovas gali prieštarauti dėl savo kaltės arba įrodinėti ieškovo
        kaltę, todėl gali būti, kad teismas pripažins, jog santuoka iširo dėl
        paties ieškovo ar abiejų sutuoktinių kaltės.
      </p>
      <p>
        Tokios bylos nagrinėjamos ieškininės teisenos tvarka, ir, esant
        reikalui, byla gali būti sprendžiama uždarame posėdyje. Tai dažniausiai
        būna brangus, ilgas, daug pastangų reikalaujantis procesas. Sutuoktinio
        kaltę būtina įrodyti liudytojų parodymais arba dokumentais:
        charakteristikomis, policijos, medicininių, socialinių paslaugų, vaiko
        teisių apsaugos institucijų pažymomis ir kt..
      </p>
      <p>
        Žinotina, kad santuoką nutraukus dėl vieno sutuoktinio kaltės, kaltasis
        sutuoktinis praranda įstatyme ar vedybų sutartyje numatytas
        išsituokusiojo teises, įskaitant teisę į išlaikymą. Kitas sutuoktinis
        turi teisę reikalauti iš kaltojo atlyginti turtinę ir neturtinę žalą,
        susijusią su santuokos nutraukimu. Ši nuostata netaikoma, jeigu santuoka
        nutraukta dėl abiejų sutuoktinių kaltės. Kaltas dėl santuokos nutraukimo
        sutuoktinis kito sutuoktinio reikalavimu privalo grąžinti iš jo gautas
        dovanas, išskyrus vestuvinį žiedą. Jeigu santuoka nutraukta dėl abiejų
        sutuoktinių kaltės, abu sutuoktiniai turi teisę reikalauti grąžinti
        vienas kitam dovanotus nekilnojamuosius daiktus, jeigu nuo dovanojimo
        sutarties sudarymo nėra praėję daugiau kaip dešimt metų ir
        nekilnojamasis daiktas nėra perleistas tretiesiems asmenims.
      </p>
      <p>
        Jeigu šeima gyvena vienam sutuoktiniui priklausančiame bute, teismas
        gali uzufrukto teise palikti kitą sutuoktinį gyventi, jeigu su juo po
        skyrybų lieka gyventi nepilnamečiai vaikai, iki šiems sueis
        pilnametystė.
      </p>
      <p>
        Jeigu vienas sutuoktinis augina bendrą savo ir buvusiojo sutuoktinio
        vaiką, arba yra nedarbingas dėl savo amžiaus ar sveikatos būklės, jam iš
        kito gali būti priteistas išlaikymas.
      </p>
      <p>
        Sutuoktinis, dėl santuokos sudarymo ir bendrų šeimos interesų ar vaikų
        priežiūros negalėjęs įgyti kvalifikacijos (baigti studijų), gali
        reikalauti iš antrojo išlaidų atlyginimo.
      </p>
      <p>
        Sprendžiant apie išlaikymo dydį, atsižvelgiama į santuokos trukmę,
        abiejų sutuoktinių materialinę padėtį, sutuoktinio elgesį, indėlį,
        kaupiant bendrąjį turtą, arba tyčinį kenkimą kitam tą turtą sukaupti.
      </p>
      <p>
        Sutuoktiniui, iš kurio buvo priteistas išlaikymas mirus, pareiga mokėti
        išlaikymą pereina jo įpėdiniams, kiek leidžia paveldimas turtas,
        neatsižvelgiant į palikimo priėmimo būdą.
      </p>
      <p>
        Santuokos nutraukimas, sutuoktinių turtinėms teisėms, teisines pasekmes
        sukelia nuo santuokos nutraukimo bylos iškėlimo. Todėl visi sandoriai,
        susiję su sutuoktinių bendrąja jungtine nuosavybe, po bylos dėl skyrybų
        iškėlimo dienos, slapčia ar nesąžiningai vieno sutuoktinio, sudaryti,
        siekiant savanaudiškų arba antrajam žalingų kėslų, kito sutuoktinio
        prašymu gali būti pripažinti negaliojančiais.
      </p>
    </div>
  </div>
</template>
